import { createContext, useContext, type ReactNode } from 'react';

import type { SearchTreeNode } from '@/types';

const CurrentSearchTreeContext = createContext<SearchTreeNode | undefined | null>(null);

type CurrentSearchTreeProviderProps = {
  children: ReactNode;
  currentSearchTree: SearchTreeNode | undefined;
};

export function CurrentSearchTreeProvider({
  children,
  currentSearchTree,
}: CurrentSearchTreeProviderProps) {
  return (
    <CurrentSearchTreeContext.Provider value={currentSearchTree}>
      {children}
    </CurrentSearchTreeContext.Provider>
  );
}

/**
 * Returns the current search tree, or null if it is not set. Calling this
 * outside of a CurrentSearchTreeProvider is not considered an error, but
 * instead an indicator that nothing should be done with it.
 *
 * Motivation: To be used when a delete button is clicked to add confirmation if
 * there is a placeholder that will get deleted. That isn't relevant outside of
 * the template building context, so nothing is done.
 */
export function useCurrentSearchTree(): SearchTreeNode | undefined | null {
  return useContext(CurrentSearchTreeContext);
}
